import styled from 'styled-components';

export type ArrowDirection = 'left' | 'right' | 'top' | 'down';

export interface ArrowProps {
  color?: string;
  direction: ArrowDirection;
  size?: number;
  weight?: number;
}

const setArrowDirection = (arrowProps: ArrowProps): string => {
  const { direction } = arrowProps;
  const weight = arrowProps.weight || '1';

  switch (direction) {
    case 'left': {
      return `${weight}px 0 0 ${weight}px`;
    }
    case 'right': {
      return `0 ${weight}px ${weight}px 0`;
    }
    case 'top': {
      return `${weight}px ${weight}px 0 0`;
    }
    case 'down': {
      return `0 0 ${weight}px ${weight}px`;
    }
    default: {
      return '';
    }
  }
};

export const Arrow = styled.i<ArrowProps>`
  align-self: center;
  border: ${({ color = 'rgb(0, 69, 165)' }) => `solid ${color}`};
  border-width: ${(props) => setArrowDirection(props)};
  display: inline-block;
  height: ${({ size = 5 }) => `${size}px`};
  margin: ${({ theme }) => `0 ${theme.spacing.base.xs}`};
  width: ${({ size = 5 }) => `${size}px`};
  transform: rotate(-45deg);
`;
